import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TermsService } from '@b2b/components/terms/terms.service';
import { map } from 'rxjs';

@Component({
  selector: 'terms',
  imports: [CommonModule],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {
  content$ = this.termsService.getContent().pipe(map(response => response));

  constructor(private termsService: TermsService) {}
}
